import { getExportJobDetails } from '@/features/AudienceManager/services';
export const fetchExportJobDetails = (bachId) => {
    return getExportJobDetails(bachId).then(response => formatValue(response?.data));
};
const formatValue = (response) => {
    return {
        success: response?.success,
        result: {
            code: response.data.result.code,
            progress: response.data.result.progress,
            url: response.data.result.url,
        },
    };
};
